import { gql } from '@apollo/client'

export const CREATE_DRAFT_INVOICE_MUTATION = gql`
  mutation createDraftInvoice($processingId: ID!) {
    createDraftInvoice(processingId: $processingId)
  }
`
